import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {AddIcon, TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import HeadTittle from '../../../../components/HeadTittle';
import SiosApp from "./Functionality/SiosApp";
import MainSiosTable from "./SubComponents/MainSiosTable";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Sios = () => {

    const {
        DEV,
        permission,
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    } = SiosApp();

    return (
        <>
            <HeadTittle name={'SIOs'}>
                {(DEV || permission?.includes(permissionObj?.WEB_HID_CREATE)) && (
                    <ButtonAction
                        id='btn_si_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setCreateModalShow(true);
                        }}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_HID_DELETE)) && (
                    <ButtonAction
                        id='btn_si_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteModalShow(true);
                        }}
                    />
                )}
            </HeadTittle>
            <MainSiosTable
                selectedList={selectedList}
                setSelectedList={setSelectedList}
                deleteModalShow={deleteModalShow}
                setDeleteModalShow={setDeleteModalShow}
                createModalShow={createModalShow}
                setCreateModalShow={setCreateModalShow}
            />

        </>
    );
};

export default Sios;
